var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.ready)?_c('page'):_c('div',{staticClass:"loader"},[_vm._v("Loading...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }